<template>
  <div>
    <a-form-item label="厂商">
      <a-select
        :loading="loadingProducerOptions"
        @change="fetchModelOptions"
        show-search
        :filter-option="filterOption"
        v-decorator="[
          'comm_module_producer_id',
          { rules: [{ required: true, message: '请选择厂商' }] },
        ]"
        placeholder="请选择"
      >
        <a-select-option
          v-for="record in producerOptions"
          :key="record.sub_type_slug"
          :value="record.id"
        >
          {{ record.name }}
        </a-select-option>
      </a-select>
    </a-form-item>

    <a-form-item label="型号">
      <a-select
        :loading="loadingModelOptions"
        @change="fetchPreOrderItemLastRemarks"
        show-search
        :filter-option="filterOption"
        v-decorator="[
          'comm_module_model_id',
          { rules: [{ required: true, message: '请选择型号' }] },
        ]"
        placeholder="请选择"
      >
        <a-select-option
          v-for="record in modelOptions"
          :key="record.id"
          :value="record.id"
        >
          {{ record.name }}
        </a-select-option>
      </a-select>
    </a-form-item>

    <a-form-item
      label="价格"
      required="required"
    >
      <a-space>
        <a-input-number
          :min="0"
          :max="10000000"
          :step="0.01"
          :precision="2"
          style="width: 120px"
          @change="handleProductPriceChange"
          v-decorator="[`distributor_price`, {
            rules: [
              { required: true, message: '请输入标准价' },
              { type: 'number', message: '请输入 0 - 10000000 之间的数字' }
            ]
          }]"
        />
        <span>元</span>
      </a-space>
    </a-form-item>

    <a-form-item label="数量" required="required">
      <a-space>
        <a-input-number
          :min="1"
          :max="productCountMaxValue"
          :step="1"
          :precision="0"
          style="width: 120px"
          :formatter="parseProductCountInputValue"
          :parser="parseProductCountInputValue"
          @change="handleProductCountChange"
          v-decorator="['product_count', {
            rules: [
              { required: true, message: '请输入采购数量' }
            ]
          }]"
        />
        <span>台</span>
      </a-space>
    </a-form-item>

    <a-form-item label="产品备注">
      <a-textarea
        v-decorator="['product_remark', {
          rules: [
            { max: 200, message: '最多200个字符' },
          ]
        }]"
        :auto-size="{ minRows: 2, maxRows: 5 }"
      />
    </a-form-item>

    <a-descriptions
      :column="1"
      class="iotplt-descriptions iotplt-descriptions-max-6"
    >
      <a-descriptions-item label="费用(元)">
        {{ productFeeDisplay }}
      </a-descriptions-item>

      <a-descriptions-item label="小计(元)">
        {{ totalFeeDisplay }}
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
import { formatFloat } from '@/utils/filter'
import { findCommonTypeOptions } from '@/api/common_type'
import { findPreOrderItemLastRemarks } from '@/api/agent_pre_order_item'

export default {
  name: 'NewProductForm',
  props: {
    form: {
      type: Object,
      required: true
    },
    agentId: {
      type: Number,
      required: true
    },
    productTypeId: {
      type: Number,
      required: true
    }
  },
  data() {
    this.calculateProductFee = this.$lodash.debounce(this.calculateProductFee, 400)
    return {
      producerOptions: [],
      loadingProducerOptions: true,
      modelOptions: [],
      loadingModelOptions: true,

      modelId: 0,

      productCountMaxValue: 10000000,
      productFeeDisplay: '', // 产品费用
      totalFeeDisplay: '' // 总费用
    }
  },
  created() {
    this.fetchProducerOptions()
  },
  methods: {
    // 加载模组类型
    fetchProducerOptions() {
      this.loadingProducerOptions = true
      findCommonTypeOptions('product_module_producer').then((res) => {
        if (res.code === 0) {
          this.producerOptions = res.data
        }
        this.loadingProducerOptions = false
      })
    },

    // 加载模组类型
    fetchModelOptions() {
      this.loadingModelOptions = true
      findCommonTypeOptions('product_module_chinamobile_model').then((res) => {
        if (res.code === 0) {
          this.modelOptions = res.data
        }
        this.loadingModelOptions = false
      })
    },

    parseProductCountInputValue(val) {
      if (!val) {
        return ''
      }

      if (val < 1) {
        val = 1
      } else if (val > this.productCountMaxValue) {
        val = this.productCountMaxValue
      }
      return parseInt(val)
    },

    // 处理改变采购价格
    handleProductPriceChange(productCount) {
      this.clearFeeDisplay()
      if (productCount > 0) {
        this.calculateProductFee()
      }
    },

    // 处理改变采购数值
    handleProductCountChange(productCount) {
      this.clearFeeDisplay()
      if (productCount > 0) {
        this.calculateProductFee()
      }
    },

    calculateProductFee() {
      this.form.validateFields(['distributor_price', 'product_count'], { force: true }, (err, values) => {
        if (!err) {
          this.productFeeDisplay = `${formatFloat(values.distributor_price)} * ${values.product_count} = ${formatFloat(values.distributor_price * values.product_count)}`
          this.totalFeeDisplay = `${formatFloat(values.distributor_price)} * ${values.product_count} = ${formatFloat(values.distributor_price * values.product_count)}`
        }
      })
    },

    clearFeeDisplay() {
      this.productFeeDisplay = ''
      this.totalFeeDisplay = ''
    },

    fetchPreOrderItemLastRemarks(value) {
      this.modelId = value

      findPreOrderItemLastRemarks({
        agent_id: this.agentId,
        product_type_id: this.productTypeId,
        comm_module_model_id: this.modelId
      }).then((res) => {
        if (res.code === 0) {
          this.form.setFieldsValue({
            product_remark: res.data.product_remark,
            delivery_remark: res.data.delivery_remark,
            invoice_remark: res.data.invoice_remark
          })
        }
      })
    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    }
  }
}
</script>

<style lang="less" scoped>
.product-price-wrapper{
  max-height: 250px;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }

  &::-webkit-scrollbar-track {
    background: #fff;
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 10px;
  }
}

.product-select-box {
  margin: 0 10px 5px 0;
  border-radius: 0 !important;
  border: 1px solid #d9d9d9;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &.product-type-box {
    min-width: 115px;
    max-width: 240px;
  }

  &.product-shape-box {
    min-width: 105px;
    max-width: 220px;
  }
}

</style>
